export default function /* @ngInject */ authMiddleware($rootScope, $location, events, showToast, nextDispatcher, userPermissions, config, $log) {
    let authenticated = Boolean(window.user);

    $rootScope.$on(events.authChange, (event, _authenticated) => {
        authenticated = _authenticated;
    });

    $rootScope.$on('$routeChangeStart', (event, next) => {
        if (next.restrictPermission) {
            let permission = next.restrictPermission;
            userPermissions.can(permission, 'routing')
                .then((can) => can ? route() : bounce())
                .catch(bounce);
        } else {
            route();
        }

        function route() {
            // Make route available in rootScope.
            $rootScope.route = next;
            // Make sure logged in users can only see views for logged in users.
            if (!authenticated && next.restrictAuthenticated === true) {
                let path = $location.path();
                showToast('You need to be logged in for that!', 'warn');
                $location.path('/').search('next', path);
            }
            // Make sure logged out users can only see views for logged out users.
            else if (authenticated && next.restrictAuthenticated === false) {
                showToast('You’re already logged in.');
                nextDispatcher();
            }
        }

        function bounce() {
            $location.path('/unauthorised');
            $log.debug('no access to route', next);
        }
    });

}



// WEBPACK FOOTER //
// ./auth/auth-middleware.js